import {useQuery} from "react-query";
import axios from "axios";
import {useSnackbar} from "notistack";
import {DailyReportTotals} from "../types/DailyReportTotalizers.types";

const API_URL = "api/daily-report/totalizers";

const fetchTotalizers = async (
    dateTime: string | null,
    powerStationIds?: number[] | null
): Promise<DailyReportTotals> => {
    if (!dateTime) {
        throw new Error("Data não selecionada");
    }

    try {
        const params = new URLSearchParams();
        params.append("dateTime", dateTime);
        if (powerStationIds && powerStationIds.length > 0) {
            powerStationIds.forEach((id) => params.append("powerStationIds", String(id)));
        }

        const response = await axios.get<DailyReportTotals>(API_URL, {
            params,
            timeout: 30000,
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar totalizadores do acompanhamento diário:", error);
        return Promise.reject(error);
    }
};

export const useDailyReportTotalizersQuery = (
    dateTime: string | null,
    powerStationIds?: number[] | null
) => {
    const {enqueueSnackbar} = useSnackbar();

    return useQuery({
        queryKey: ["daily-report-totalizers", dateTime, powerStationIds],
        queryFn: () => fetchTotalizers(dateTime, powerStationIds),
        enabled: !!dateTime,
        onError: (error: any) => {
            const errorMessage =
                error?.response?.data?.message ||
                error?.response?.data?.detail ||
                error?.message ||
                "Erro ao carregar totalizadores do acompanhamento diário";
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 3000,
            });
        },
    });
};
